export class CONSTANTS_SIASE {
    public static Portafolio = {
        BotonEnviarCalificacionesSIASE: null,
        ColumnaCalificacionSIASE: null,
    }
}